import { TextLink } from '@/components/TextLink';

type ArticlesListProps = {
  articles: {
    title?: string | null;
    slug?: string | null;
  }[];
};

export const ArticleList = ({ articles }: ArticlesListProps) =>
  articles ? (
    <ul className="list-none">
      {articles.map(({ title, slug }, index) => (
        <li className="border-b border-base-200" key={index}>
          <TextLink
            className="font-semibold block my-3 py-5 mx-5 hover:bg-transparent focus:bg-transparent lg:text-lg"
            href={`/help/article/${slug}`}
          >
            {title}
          </TextLink>
        </li>
      ))}
    </ul>
  ) : null;
